// src/pages/Quiz.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import QuizForm from "../components/quiz/QuizForm";
import Handoff from "../components/quiz/Handoff";
import ResultsDecision from "../components/quiz/ResultsDecision";

function Quiz({ quizState, setQuizState }) {
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState("form"); // 'form' | 'handoff' | 'results-decision'
  const [currentSelections, setCurrentSelections] = useState([]);

  const currentPersonNumber = quizState.currentPersonIndex + 1;
  const isLastPerson = currentPersonNumber >= quizState.totalPeople;

  // When a person completes their form
  const handlePersonComplete = () => {
    // Save this person's responses
    const newResponses = [
      ...quizState.responses,
      {
        personNumber: currentPersonNumber,
        activities: currentSelections,
      },
    ];

    setQuizState({
      ...quizState,
      responses: newResponses,
      currentPersonIndex: quizState.currentPersonIndex + 1,
    });

    // Clear selections for next person
    setCurrentSelections([]);

    // If this was the last required person, show results decision
    // Otherwise show handoff screen
    if (isLastPerson) {
      setCurrentView("results-decision");
    } else {
      setCurrentView("handoff");
    }
  };

  // When handoff "I'm Ready" is clicked
  const handleHandoffReady = () => {
    setCurrentView("form");
  };

  // When "See Results" is clicked
  const handleSeeResults = () => {
    setQuizState({ ...quizState, isComplete: true });
    navigate("/results");
  };

  // When "Add Person X" is clicked
  const handleAddPerson = () => {
    setQuizState({
      ...quizState,
      totalPeople: quizState.totalPeople + 1,
    });
    setCurrentView("handoff");
  };

  // Render the appropriate view
  if (currentView === "form") {
    return (
      <QuizForm
        personNumber={currentPersonNumber}
        selectedActivities={currentSelections}
        onSelectionChange={setCurrentSelections}
        onComplete={handlePersonComplete}
      />
    );
  }

  if (currentView === "handoff") {
    return (
      <Handoff
        completedPersonNumber={currentPersonNumber - 1}
        nextPersonNumber={currentPersonNumber}
        onReady={handleHandoffReady}
      />
    );
  }

  if (currentView === "results-decision") {
    return (
      <ResultsDecision
        completedCount={quizState.responses.length}
        nextPersonNumber={quizState.totalPeople + 1}
        onSeeResults={handleSeeResults}
        onAddPerson={handleAddPerson}
      />
    );
  }

  return null;
}

export default Quiz;
